import { Component } from "react"

/* Livekit */
import * as LiveKit from "livekit-client"

/* REST API */
import { getToken } from "../api/Livekit"


/* Component Video */
class Video extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
        }
    }

    componentWillUnmount = () => {
        this.setState({ visible: false })
    }

    /* Toggle Livekit */
    toggle = () => {

        /* Fields */
        const { room: _room, serviceURL } = this.props
        const { visible } = this.state

        this.setState({ visible: !visible })

        /* Check Room */
        if (_room && !visible) {

            /* Create Room */
            const room = new LiveKit.Room({ adaptiveStream: true, dynacast: true })
            this._room = room

            /* On Connect */
            room.on(LiveKit.RoomEvent.TrackSubscribed, (track) => {

                const video = document.getElementById("wrtc-video")
                video.autoplay = true
                video.playsInline = true

                /* Play Video */
                if (track.kind === "video") {
                    track.attach(video)
                }

                if (track.kind === "audio") {
                    track.attach(video)
                }

            })

            /* Send to REST API */
            getToken(serviceURL, { room: _room }).then(async (response) => {
                if (response.status === 200) {

                    await room.connect(response.data.socketURL, response.data.token)

                    room.localParticipant.setMicrophoneEnabled(false)
                    room.localParticipant.setCameraEnabled(false)

                }
            })
        }

    }

    render = () => {

        /* Fields */
        const { visible } = this.state

        return (
            <div className={`game-video ${visible ? "opened" : "closed"}`}>

                <div onClick={() => this.toggle()} className="game-video-live">
                    <div className="game-video-live-text">Live</div>
                </div>

                <div className="game-video-container">
                    {visible && <video id="wrtc-video" style={{ width: "100%", height: "100%" }} controls autoPlay muted />}
                </div>

            </div>
        )
    }

}

export default Video